import { render, staticRenderFns } from "./revenueBills-orderList.vue?vue&type=template&id=740f06c2&scoped=true&"
import script from "./revenueBills-orderList.vue?vue&type=script&lang=js&"
export * from "./revenueBills-orderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f06c2",
  null
  
)

export default component.exports